import type { ExperienceLevel } from '@/components/onboarding/types';
import type { Language } from '@/i18n/translations';

export const EXPERIENCE_LAYERS: Record<ExperienceLevel, Partial<Record<Language, string>> & { en: string }> = {
  beginner: {
    sv: 'Du pratar med en nybörjare. Ge alltid stegvisa förklaringar, definiera termer första gången de används, och visa konkreta exempel. Använd analogier ("tänk på det som...") för att bygga mentala modeller. Undvik jargong.',
    en: 'You are talking to a beginner. Always give step-by-step explanations, define terms the first time, and show concrete examples. Use analogies ("think of it like...") to build mental models. Avoid jargon.',
  },
  experienced: {
    sv: 'Du pratar med en erfaren användare som känner till visuella workflow-verktyg. Ge balanserad vägledning med exempel där det behövs, men skippa grundläggande definitioner.',
    en: 'You are talking to an experienced user familiar with visual workflow tools. Give balanced guidance with examples where needed, but skip basic definitions.',
  },
  'power-user': {
    sv: 'Du pratar med en power-user. Var extremt koncis — inga onödiga förklaringar. Gå rakt på avancerade kombinationer, shortcuts och optimeringar. Antag att användaren redan kan grunderna.',
    en: 'You are talking to a power user. Be extremely concise — no unnecessary explanations. Go straight to advanced combinations, shortcuts and optimizations. Assume the user already knows the basics.',
  },
};

export function buildExperienceLayer(experience: ExperienceLevel, lang: Language): string {
  return EXPERIENCE_LAYERS[experience][lang] ?? EXPERIENCE_LAYERS[experience].en;
}
